module.exports = __webpack_public_path__ + "static/media/mediationIcon.13ff8f01.svg";